import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "outerMargin", "containerWidths", "gutterWidths"],
    _excluded2 = ["children", "hasPaddingTop", "hasPaddingBottom", "gutterWidths"],
    _excluded3 = ["children", "centerX", "topSpacing", "bottomSpacing", "gutterWidths"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/* Original name @uswitch/trustyle.grid */
import * as st from './styles';
import { jsx as _jsx } from "theme-ui/jsx-runtime";
var breakpoints = {
  s: 0,
  m: 640,
  l: 1152
};
export var Container = function Container(_ref) {
  var children = _ref.children,
      outerMargin = _ref.outerMargin,
      containerWidths = _ref.containerWidths,
      gutterWidths = _ref.gutterWidths,
      props = _objectWithoutProperties(_ref, _excluded);

  return _jsx("div", _objectSpread(_objectSpread({
    css: st.container(outerMargin, containerWidths, gutterWidths)
  }, props), {}, {
    children: children
  }));
};

var parseSizeFromProps = function parseSizeFromProps(fn) {
  return Object.entries(breakpoints).map(fn);
};

var parseDisplay = function parseDisplay(props) {
  return parseSizeFromProps(function (_ref2) {
    var _ref3 = _slicedToArray(_ref2, 1),
        key = _ref3[0];

    return props["hide-".concat(key)] ? 'none' : 'block';
  });
};

var parseSizes = function parseSizes(props) {
  return parseSizeFromProps(function (_ref4) {
    var _ref5 = _slicedToArray(_ref4, 1),
        key = _ref5[0];

    return parseFloat(props[key]) || 1;
  });
};

export var Column = function Column(_ref6) {
  var children = _ref6.children,
      hasPaddingTop = _ref6.hasPaddingTop,
      hasPaddingBottom = _ref6.hasPaddingBottom,
      gutterWidths = _ref6.gutterWidths,
      props = _objectWithoutProperties(_ref6, _excluded2);

  var sizes = parseSizes(props);
  var display = parseDisplay(props);
  return _jsx("div", _objectSpread(_objectSpread({
    css: st.column(sizes, display, hasPaddingTop, hasPaddingBottom, gutterWidths)
  }, props), {}, {
    children: children
  }));
};
export var Row = function Row(_ref7) {
  var children = _ref7.children,
      centerX = _ref7.centerX,
      topSpacing = _ref7.topSpacing,
      bottomSpacing = _ref7.bottomSpacing,
      gutterWidths = _ref7.gutterWidths,
      props = _objectWithoutProperties(_ref7, _excluded3);

  return _jsx("div", _objectSpread(_objectSpread({
    css: st.row(centerX, topSpacing, bottomSpacing, gutterWidths)
  }, props), {}, {
    children: children
  }));
};